import { render } from "./Organization.vue?vue&type=template&id=4221d65f&scoped=true"
import script from "./Organization.vue?vue&type=script&lang=js"
export * from "./Organization.vue?vue&type=script&lang=js"

import "./Organization.vue?vue&type=style&index=0&id=4221d65f&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4221d65f"]])

export default __exports__